import {ChoiceValueDecisionState, ConfigurationInterpreter} from '@viamedici-spc/configurator-ts';
import {stringToAttributeId} from '../components/spc/util/spcUtils';

export function conditional(spcConfiguration, conditionalVariantValues, id, type = 'EditorialTable', side = 1) {
	if (conditionalVariantValues === null) {return null;}
	const conditionalValues = getConditionalVariantValue(spcConfiguration, conditionalVariantValues, id, type, side);
	if (conditionalValues && conditionalValues.length > 0) {
		//console.log(' match: ', id, conditionalValues[0].value);
		return conditionalValues[0].value;
	} else {
		// console.log('no match: ', id, conditionalValues, conditionalVariantValues);
		return null;
	}
}
export function conditionalWithConditions(conditions, conditionalVariantValues, id, type = 'EditorialTable', side = 1) {
	if (conditionalVariantValues === null) {return null;}
	const conditionalValues = getConditionalVariantValueStaticConditions(conditions, conditionalVariantValues, id, type, side);
	if (conditionalValues && conditionalValues.length > 0) {
		//console.log(' match: ', id, conditionalValues[0].value, conditionalValues);
		return conditionalValues[0].value;
	} else {
		//console.log('no match: ', id, conditionalValues, conditions);
		return null;
	}
}
export function conditionals(spcConfiguration, conditionalVariantValues, id, type = 'EditorialTable', side = null) {
	let conditionalValues;
	if (side === null) {
		conditionalValues = [
			...getConditionalVariantValue(spcConfiguration, conditionalVariantValues, id, type, 1) ?? [],
			...getConditionalVariantValue(spcConfiguration, conditionalVariantValues, id, type, 2) ?? []
		];
	} else {
		conditionalValues = getConditionalVariantValue(spcConfiguration, conditionalVariantValues, id, type, side);
	}
	return conditionalValues;
}

function getConditionalVariantValue(spcConfiguration, conditionalVariantValues, id, type, side = 1) {
	if (conditionalVariantValues === null) {
		return null;
	}

	// WORKAROUND: Remove 'RETURN_' from id
	id = id.replace('REDTAB.RETURN_', '').replace('RETURN_', '');
	// collect all values where id and decisions match
	const key = type + '.' + id + '.' + side;
	if (spcConfiguration && conditionalVariantValues && key in conditionalVariantValues) {
		const matchingValues = conditionalVariantValues[key].filter(
			conditionalVariantValue => conditionalVariantValue.conditions.reduce(
				(match, condition) => {
					const parts = condition.split('.');
					const choiceValue = ConfigurationInterpreter.getChoiceValue(
						spcConfiguration,
						stringToAttributeId(parts[0]),
						parts[1]
					);
					return choiceValue?.decision?.state === ChoiceValueDecisionState.Included && match;
				}, true
			));

		if (matchingValues.length > 0) {
			return matchingValues;
		}
	}
	return null;
}
function getConditionalVariantValueStaticConditions(conditions, conditionalVariantValues, id, type, side = 1) {
	if (conditionalVariantValues === null) {
		return null;
	}

	// WORKAROUND: Remove 'RETURN_' from id
	id = id.replace('REDTAB.RETURN_', '').replace('RETURN_', '');
	// collect all values where id and decisions match
	const key = type + '.' + id + '.' + side;
	if (conditions && key in conditionalVariantValues) {
		const matchingValues = conditionalVariantValues[key].filter(
			conditionalVariantValue => conditionalVariantValue.conditions.every(a => conditions.includes(a)));

		if (matchingValues.length > 0) {
			return matchingValues;
		}
	}
	return null;
}
